import { useLanguage } from "@/lib/i18n/LanguageContext";
import { formatRole } from "@/constants/permissions";

/**
 * Returns a function that maps an org-role code (`org_owner` / `org_admin` /
 * `subcontractor`) to its human-readable label in the active UI language.
 *
 * Role labels used to live only in `formatRole`, which hardcoded English, so
 * they stayed English even when the rest of the UI was Estonian. This hook
 * reads the labels from the i18n `settings.roles.roleLabels` map instead, and
 * falls back to `formatRole` for any role code that has no translation.
 */
export function useRoleLabel(): (role: string) => string {
  const { t } = useLanguage();
  const labels = t.settings.roles.roleLabels as Record<string, string>;
  return (role: string) => labels[role] ?? formatRole(role);
}
